import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./fieldset.component.html?ngResource";
import { Component, Input } from '@angular/core';
let FieldSetComponent = class FieldSetComponent {
    header = 'Info';
    toggleable = false;
    collapsed = true;
    static propDecorators = {
        header: [{ type: Input }],
        toggleable: [{ type: Input }],
        collapsed: [{ type: Input }]
    };
};
FieldSetComponent = __decorate([
    Component({
        selector: 'field-set',
        template: __NG_CLI_RESOURCE__0
    })
], FieldSetComponent);
export { FieldSetComponent };
